// src/pages/SeniorCollege.js
import React, { useState, useEffect } from 'react';

import CategorySection from '../components/CategorySection'; // Import the reusable component
import '../../style/components/FormView.css';  // Ensure correct path to your CSS file

const SeniorCollege = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const nonAgriculturalTeachingLinks = [
    { href: "/daArrearsForm", text: "D.A. Arrears" }
  ];


  // Data for the links
  const nonAgriTeachingLinks = [
    // { href: "forms/NewAppointment.html", text: "New Appointment" },
    { href: "/srPlacementForm", text: "Placement In Seventh Pay (2016 onwards)" },
    // { href: "forms/Promotion.html", text: "Promotion" },
    // { href: "forms/PayCommission5.html", text: "Pay Commission 5" },
    // { href: "forms/PayCommission6.html", text: "Pay Commission 6" },
    // { href: "forms/PayCommission7.html", text: "Pay Commission 7" },
  ];

  const nonAgriNonTeachingLinks = [
    { href: "forms/ACP1.html", text: "ACP1" },
    { href: "forms/ACP2.html", text: "ACP2" },
    { href: "forms/PromotionNonTeaching.html", text: "Promotion" },
    { href: "forms/NewAppointmentNonTeaching.html", text: "New Appointment" },
  ];

  return (

      <div className={`FormView ${isLoading ? 'is-loading' : ''}`}>
      {isLoading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <div className="loading-text">Loading Resources...</div>
        </div>
      ) : (
        <>
          <h1 className="page-title">Senior College</h1>

        <div className="section-container">
          {/* Non Agri Teaching Section */}
          <CategorySection title="Non Agricultural Teaching" links={nonAgriTeachingLinks} />

          {/* Fading Line Divider */}
          <div className="divider"></div>

          {/* Non Agri Non-Teaching Section */}
          {/* <CategorySection title="Non Agricultural Non-Teaching" links={nonAgriNonTeachingLinks} /> */}
         </div>
        </>
      )}
    </div>
  );
};

export default SeniorCollege;